var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVelocityIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0C14.0595 0 13.5 0.55975 13.5 1.25C13.5 1.39175 13.5288 1.5255 13.572 1.6525L10.525 4.27625C10.3112 4.106 10.0445 4 9.75 4C9.41027 4 9.10302 4.1365 8.878 4.3565L6.49125 3.1615C6.44477 2.51325 5.91002 2 5.25 2C4.55977 2 4 2.55975 4 3.25C4 3.439 4.045 3.61625 4.12 3.77675L1.6865 6.58275C1.55 6.53175 1.40425 6.5 1.25 6.5C0.55975 6.5 0 7.05975 0 7.75C0 8.44025 0.55975 9 1.25 9C1.94025 9 2.5 8.44025 2.5 7.75C2.5 7.58375 2.466 7.42552 2.407 7.2805L4.88 4.438C4.99775 4.4745 5.12025 4.5 5.25 4.5C5.61375 4.5 5.93823 4.342 6.16673 4.09375L8.50123 5.26425C8.5095 5.94775 9.06448 6.5 9.75 6.5C10.4405 6.5 11 5.94025 11 5.25C11 5.22775 10.9948 5.207 10.9935 5.185L14.245 2.39175C14.3997 2.46025 14.5697 2.5 14.75 2.5C15.4405 2.5 16 1.9405 16 1.25C16 0.55975 15.4405 0 14.75 0Z",
    fill: "#082B72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelocityIcon);
export default __webpack_public_path__ + "static/media/velocity_icon.71968d8bdeb34f6c2993d00a11bf906e.svg";
export { ForwardRef as ReactComponent };